export const EVENT_ORIGIN = {
  GOOGLE_CALENDAR: "googleCalendar",
  WEMBII_CALENDAR: "wembiiCalendar"
}